<template>
  <v-navigation-drawer app class="asta-drawer" v-model="drawer" fixed temporary>
    <div class="drawer-header navy">
      <v-avatar class="drawer-user-avatar" size="34">
        <v-img v-if="user_pic" contain :src="user_pic"></v-img>
        <v-icon v-else color="white">account_circle</v-icon>
      </v-avatar>

      <div class="drawer-user-info">
        <div class="drawer-user-name white--text">
          {{ user_displayName || user_uid }}
        </div>
        <div class="drawer-league-row secondary--text">
          <v-icon x-small class="drawer-league-icon secondary--text">
            security
          </v-icon>
          <span class="drawer-league-name">
            {{ asta_info.name }}
          </span>
        </div>
      </div>

      <v-spacer></v-spacer>
      <v-btn rounded class="white--text" icon @click="toggle">
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <v-divider></v-divider>

    <div
      class="error white--text pa-2 ma-2"
      style="border-radius: 3px"
      v-if="!admin && !my_squadra"
    >
      Solo i presidenti delle squadre possono partecipare all'asta. I co-gestori
      e gli ospiti non possono parteciparvi ma possono seguirne l'andamento.
    </div>

    <v-list dense>
      <!-- Mia squadra -->
      <v-list-item v-if="my_squadra" link @click="promptEditSquadra">
        <v-list-item-icon>
          <v-img
            v-if="mySquadraPic"
            contain
            :src="mySquadraPic"
            class="drawer-team-icon"
          ></v-img>
          <v-icon v-else color="text">admin_panel_settings</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            ><div class="font-weight-bold">La mia squadra</div>
          </v-list-item-title>
          <v-list-item-subtitle> {{ mySquadraName }} </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- sblocca -->
      <v-list-item link @click="promptSblocco" v-if="!premium">
        <v-list-item-icon>
          <v-icon color="orange">workspace_premium</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="orange--text font-weight-bold"
            >Sblocca</v-list-item-title
          >
          <v-list-item-subtitle
            ><div v-if="asta_info.counter">
              Hai ancora <b>{{ asta_info.counter }}</b> assegnazioni.
            </div>
            <div v-else>Sblocca per continuare.</div></v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Amministratore asta -->
      <v-list-item link v-if="admin || my_squadra" @click="promptChangeAdmin">
        <v-list-item-icon>
          <v-icon color="text">engineering</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Amministratore Asta
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ adminUsername }}
            <div class="stato" :class="adminPresenceClass"></div
          ></v-list-item-subtitle>
          <div
            :class="{
              'error--text': adminPresence != Constants.PRESENCE_STATES.ONLINE,
            }"
          >
            L'amministratore deve rimanere sempre online durante il corso
            dell'asta o Asta Live si bloccherà.
          </div>
        </v-list-item-content>
      </v-list-item>

      <!-- Impostazioni -->
      <!-- <v-list-item link @click="promptImpostazioni" v-if="admin || my_squadra">
        <v-list-item-icon>
          <v-icon color="text">settings</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Impostazioni asta</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item> -->

      <!-- pianifica -->
      <!-- <v-list-item link @click="showPlan">
        <v-list-item-icon>
          <v-icon color="text">design_services</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Pianifica crediti <span class="ml-1 error white--text px-1 rounded d-inline-flex">new</span></v-list-item-title
          >
          <v-list-item-subtitle>Ex Asta-Manager </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item> -->

      <!-- download -->
      <v-list-item link v-if="admin || my_squadra" @click="promptDownloadRose">
        <v-list-item-icon>
          <v-icon color="text">download</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Download Rose</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Invita -->
      <v-list-item link v-if="admin || my_squadra" @click="openDialogInvito">
        <v-list-item-icon>
          <v-icon color="text">person_add</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Invita</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- <div class="text-center my-4">
      <v-btn small rounded class="orange white--text" @click="openDialogInvito">
        <v-icon small left>fa-plus-circle</v-icon> INVITA ALL'ASTA
      </v-btn>
    </div> -->

      <!-- Supporto -->
      <v-list-item link>
        <v-list-item-icon>
          <v-icon color="text">support </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            ><a
              class="blue-grey--text text-decoration-none"
              href="https://www.facebook.com/groups/500245610367729/"
              target="_blank"
              >Supporto</a
            ></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Come funziona -->
      <v-list-item link @click="promptComeFunziona">
        <v-list-item-icon>
          <v-icon color="secondary">not_listed_location</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="secondary--text font-weight-bold"
            >Come funziona?</v-list-item-title
          >
          <v-list-item-subtitle>Guida veloce a Asta Live</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

       <!-- Novità -->
      <v-list-item link class="drawer-news-icon" @click="promptChangeLog">
        <v-list-item-icon>
          <v-icon color="text">new_releases</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Novità Asta Live
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- weblink -->
      <!-- <v-list-item link v-if="is_mobile" @click="gotoAsta">
        <v-list-item-icon>
          <v-icon color="text">language</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Web link
            <v-icon x-small right class="text--text"
              >open_in_new</v-icon
            ></v-list-item-title
          >
          <v-list-item-subtitle
            >Asta Live è disponibile anche in<br />
            una più comoda versione desktop<br />
            <span
              class="text--text text--lighten-2 text-decoration-underline"
              >{{ urlAsta }}</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>

    <div class="pb-2 text-center">
      <small>v. {{ version }}</small>
    </div>

    <!-- <div class="text-center">
      <v-btn small rounded outlined v-clipboard:copy="urlAsta" v-if="is_mobile">
        Copia link
      </v-btn>
    </div> -->

    <template v-slot:append>
      <v-card class="ma-4">
        <v-list dense>
          <!-- Account -->
          <v-list-item link @click="gotoHome">
            <v-list-item-icon>
              <v-icon color="text">chevron_left</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="font-weight-bold"
                ><div class="font-weight-bold">Account & Aste</div>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ user_displayName }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </template>

    <dialog-invito></dialog-invito>
  </v-navigation-drawer>
</template>

<script>
import db from "../js/db";
import Vuex from "vuex";

import mixins from "../js/mixins";
import toast from "../js/toast";
import Constants from "../js/constants";
import Config from "../../config-app/config";

import AstaChooser from "./dialogs/AstaChooser";
import DialogInvito from "./dialogs/DialogInvito";
import SquadraCrediti from "./common/SquadraCrediti";

export default {
  name: "asta-drawer-standalone",
  mixins: [mixins, toast],
  components: {
    AstaChooser,
    SquadraCrediti,
    DialogInvito,
  },

  mounted() {
    console.log("--> AstaDrawerStandalone mounted.");
    db.on("toggleDrawer", this.toggle);
    db.on("closeDrawer", this.toggle);
  },

  computed: {
    mySquadraName() {
      return this.asta_squadre[this.user_uid]
        ? this.asta_squadre[this.user_uid].name
        : "";
    },
    mySquadraPic() {
      return this.my_squadra && this.my_squadra.pic
        ? this.my_squadra.pic
        : null;
    },
    SquadraAdminName() {
      return this.asta_squadre[this.adminUid]
        ? this.asta_squadre[this.adminUid].name
        : "";
    },

    drawerClass() {
      return {
        "navigation-drawer--close": !this.drawer,
        "navigation-drawer--open": this.drawer,
      };
    },

    // shouldShowPlan() {
    // },
    ...Vuex.mapGetters([
      "tot_squadre",
      "user_displayName",
      "user_pic",
      "user_uid",
      "version",
    ]),
  },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    promptChangeAdmin() {
      db.emit("promptChangeAdmin");
    },
    openDialogInvito() {
      db.emit("invitoEmitted");
    },
    gotoHome() {
      this.$router.push({ path: "/" });
    },
    promptEditSquadra() {
      db.emit("showEditSquadra");
    },
    promptComeFunziona() {
      db.emit("showComeFunziona");
    },
    promptSblocco() {
      db.emit("showSblocco");
    },
    promptImpostazioni() {
      db.emit("showImpostazioni");
      this.drawer = false;
    },
    promptChangeLog() {
      db.emit("showChangeLog");
      this.drawer = false;
    },
    toggle() {
      this.drawer = !this.drawer;
    },
    close() {
      this.drawer = false;
    },
    promptDownloadRose() {
      db.emit("promptDownloadRose");
    },

    showPlan() {
      this.close();
      if (this.is_mobile) {
        db.emit("showDialogPlan");
      }
    },
  },
  destroyed() {
    console.log("<-- AstaDrawer destroyed.");
    db.off("toggleDrawer", this.toggle);
    db.off("closeDrawer", this.toggle);
  },
};
</script>

<style scoped>
.asta-drawer {
  width: 330px !important;
}

.drawer-header {
  display: flex;
  align-items: center;
  min-height: 70px;
  padding: 0 8px;
  flex: 0 0 auto;
}

.drawer-user-avatar {
  flex: 0 0 auto;
  margin-right: 8px;
}

.drawer-user-info {
  flex: 1 1 auto;
  min-width: 0;
}

.drawer-user-name,
.drawer-league-row,
.drawer-league-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drawer-user-name {
  font-weight: 700;
}

.drawer-league-row {
  align-items: center;
  display: flex;
  font-size: 12px;
  line-height: 1.2;
}

.drawer-league-icon {
  flex: 0 0 auto;
  margin-right: 3px;

}

.drawer-league-name {
  min-width: 0;
}

.drawer-team-icon {
  max-height: 25px;
  max-width: 25px;
    border-radius: 6px;
}

/* .version {
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
} */
</style>
